import Html from 'slate-html-serializer';

import { answerLinkRules } from './rules/answer_link_rules';
import { baseRules } from './rules/base_rules';
import { fallbackRules } from './rules/fallback_rules';
import { inlineImageRules } from './rules/inline_image_rules';
import { phraseSuggestionRules } from './rules/phrase_suggestion_rules';
import { placeholderRules } from './rules/placeholder_rules';
import { richTextRules } from './rules/rich_text_rules';
import { tableRules } from './rules/table_rules';
import { variableRules } from './rules/variable_rules';

const FullSerializer = new Html({
  rules: [
    ...baseRules,
    ...answerLinkRules,
    ...phraseSuggestionRules,
    ...inlineImageRules,
    ...placeholderRules,
    ...richTextRules,
    ...tableRules,
    ...variableRules,
    ...fallbackRules,
  ],
});

export default FullSerializer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/text_editor/serializers/full_serializer.jsx